import React, { useEffect, useState, useLayoutEffect } from "react";
import _ from "lodash";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { InputText } from "@loanbossinc/component-library";
import WizardPageLayout from "component-lib/WizardPageLayout";
import CircularProgress from "@material-ui/core/CircularProgress";
import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog";

import { dealGet } from "../../deal/deal.store";
import { actionCreators as dashboardActionCreators } from "../dashboard/dashboard.store";
import DocIcon from "../docIcon.svg";

import { actionCreators, getNewReportConfig } from "./reportingSetup.store";
import Step0 from "./step0";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import { Avatar, BackButton, Card, Container, IconWrapper } from "./styles";

export const LenderReportingSetup = props => {
  const {
    deal,
    getReportConfig,
    getNewReportConfig,
    deleteReportConfig,
    getReportConfigByReportId,
    history,
    initializeReportConfig,
    initializeState,
    isLoading,
    isDeleteDialogOpen,
    match: {
      params: { dealId, reportId }
    },
    newReportConfig,
    reportConfig,
    reportSelections,
    selectedReportId,
    setSelections,
    user: { id: userId },
    wizardStep,
    wizardStepDecrement,
    wizardStepIncrement
  } = props;

  const [deleteFormInput, setdeleteFormInput] = useState("");

  useLayoutEffect(() => () => {
    initializeState();
  }, []);

  useEffect(() => {
    if (dealId !== "notSelected" && _.isEmpty(deal)) {
      props.dealGet({ dealId });
    }
  }, [dealId, deal]);

  useEffect(() => {
    if (wizardStep === 0 && _.isEmpty(newReportConfig)) {
      getNewReportConfig();
      if (dealId) {
        wizardStepIncrement();
      }
      if (reportId) {
        getReportConfigByReportId({ reportId });
      }
    }
  }, [wizardStep]);

  useEffect(() => {
    if (reportId === "new") {
      initializeState();
      setSelections({ currentUserId: userId, selectedDealId: dealId, selectedReportId: reportId });
      initializeReportConfig();
    } else if (dealId !== "notSelected" && reportId !== "new") {
      setSelections({ currentUserId: userId, selectedDealId: dealId, selectedReportId: reportId });
      getReportConfig({ id: reportId });
      getReportConfigByReportId({ reportId });
      setSelections({ isEditing: true });
    }

    return () => {
      setSelections({ isEditing: false, reportConfig: null });
    };
  }, [reportId]);

  // Setup name and context
  const step0 = () => <Step0 {...props} />;

  // Setup name and context
  const step1 = () => <Step1 {...props} />;

  // Setup reporting periods
  const step2 = () => <Step2 {...props} />;

  // Customize calculations
  const step3 = () => <Step3 {...props} />;

  const wizard = () => {
    switch (wizardStep) {
      case 0:
        return step0();
      case 1:
        return step1();
      case 2:
        return step2();
      case 3:
        return step3();
      default:
        if (wizardStep > -1) {
          wizardStepDecrement();
        }

        return <BackButton id="back-button" label="Back" iconName="arrow_forward" reverse alignRight={false} key={1} onClick={() => history.goBack()} />;
    }
  };

  const handleDeleteConfirm = () => {
    if (deleteFormInput === "DISCARD" && selectedReportId && selectedReportId !== "new") {
      deleteReportConfig({ id: selectedReportId });
      setSelections({ isDeleteDialogOpen: false });
      setdeleteFormInput("");
      history.push(`/deal/${dealId}/lender-reports`);
    }
  };

  return (
    <>
      <WizardPageLayout
        cardComponent={
          <Container>
            <Card>
              <Avatar>
                <IconWrapper>
                  <img src={DocIcon} alt="Doc Logo" />
                </IconWrapper>
              </Avatar>
              {!isLoading && newReportConfig && reportConfig ? wizard() : <CircularProgress size={40} style={{ color: "#005AA9" }} />}
            </Card>
          </Container>
        }
      />
      <SimpleConfirmDialog
        modalOpen={isDeleteDialogOpen}
        title="Discard Report"
        message="Discarding a Report will remove all it’s underlying content and data."
        secondaryContent={
          <div>
            <p style={{ marginBottom: "2em" }}>Type DISCARD to confirm it’s removal:</p>
            <p>
              <InputText
                name="reportDeleteConfirm"
                label={"Confirm by typing \"DISCARD\""}
                value={deleteFormInput}
                onChange={e => {
                  setdeleteFormInput(e.target.value);
                }}
                style={{ width: "100%" }}
              />
            </p>
          </div>
        }
        yesText="Confirm"
        noText="Cancel"
        handleNo={() => {
          setdeleteFormInput("");
          setSelections({ isDeleteDialogOpen: false });
        }}
        handleYes={handleDeleteConfirm}
      />
    </>
  );
};

const mapStateToProps = ({ lenderReportingSetup, lenderReportList: { reportComponentsForSelectedGroup }, newDeal: { deal }, authentication: { user } }) => ({
  ...lenderReportingSetup,
  reportComponentsForSelectedGroup,
  deal,
  user
});

const mapDispatchToProps = dispatch => bindActionCreators({ ...actionCreators, ...dashboardActionCreators, dealGet, getNewReportConfig }, dispatch);

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(LenderReportingSetup);
